import styled from 'styled-components';

interface ContainerProps {
  width: string;
}

export const Container = styled.div<ContainerProps>`
  width: ${props => props.width};
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 850px) {
    width: 100%;
  }

  input {
    width: 100%;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.6rem 0.75rem;
    text-align: left;
    margin-top: 0.4rem;
    background: #fff;
    font-family: var(--font-sans);
    font-size: 0.9rem;
    color: var(--foreground);
    transition: border-color 0.15s, box-shadow 0.15s;

    &:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3);
    }

    &:disabled {
      background: var(--stone-100);
      color: var(--muted-foreground);
    }
  }

  label {
    font-weight: 500;
    font-size: 0.8rem;
    color: var(--stone-600);
  }
`;
